var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    _vm._b(
      {
        key: _vm.inputType + "-" + _vm.refreshKey,
        staticClass: "dt-form-item",
        attrs: { label: _vm.hasAinLabel ? "" : _vm.label, prop: _vm.prop },
      },
      "el-form-item",
      Object.assign({}, _vm.$attrs, _vm.itemBindProps),
      false
    ),
    [
      _c(
        _vm.componentType,
        _vm._g(
          _vm._b(
            {
              ref: "component",
              tag: "component",
              staticClass: "dt-form-item-input",
              attrs: { options: _vm.optionList },
              on: {
                error: function (error) {
                  return (_vm.itemBindProps.error = error)
                },
                correct: function ($event) {
                  _vm.itemBindProps.error = ""
                },
              },
              model: {
                value: _vm.localValue,
                callback: function ($$v) {
                  _vm.localValue = $$v
                },
                expression: "localValue",
              },
            },
            "component",
            _vm.smartComponentAttr,
            false
          ),
          _vm.$listeners
        ),
        [
          _vm._t("default"),
          _vm.hasOptions
            ? _vm._l(_vm.optionList, function (option) {
                return _c(
                  _vm.optionType,
                  _vm._b(
                    {
                      key: option[_vm.propKey.key] || option[_vm.propKey.value],
                      tag: "component",
                      attrs: {
                        label:
                          option[
                            _vm.propKey[
                              _vm.inputType == "select" ? "label" : "value"
                            ]
                          ],
                        value: option[_vm.propKey.value],
                      },
                    },
                    "component",
                    Object.assign(
                      {},
                      option,
                      (_vm.smartComponentAttr || {}).optionAttr
                    ),
                    false
                  ),
                  [_vm._v(" " + _vm._s(option[_vm.propKey.label]) + " ")]
                )
              })
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }